import React from 'react';
import UtilitiesController from './utilitiesController';
import AuthController from './authController';
import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';


export default class UserController {

    static exceptionWrapper = (fn) => async (data) => {
        try {
            return await fn(data).catch((err) => {
                throw err;
            });
        } catch (err) {
            return {
                success: false,
                error: err.app_error ? err.app_error : err.message
            }
        }
    };

    static checkSubscription = UserController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.get(`/v4/api/user/check_subscription/${data.partner_id}`, data, true);
        return response;
    });

    static changePassword = UserController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post(`/v4/api/user/change_password`, data, true);
        return response;
    });

    static validatePhoneAndUpdate = UserController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post(`/v4/api/user/validate_phone_number`, data, true);

        if(response && response.success) {
            await AsyncStorage.setItem('phone_number', data.phone_number);
        }

        return response;
    });

    static updatePaymentMethod = UserController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post(`/v3/api/care_subscription/switch_card`, data, true);

        return response;
    });

    static updateProfile = UserController.exceptionWrapper(async (data) => {
        console.log('getting to data', data)
        let response = await UtilitiesController.post(`/v4/api/user/update_profile`, data, true);
        console.log('response', response)
        if(response && response.success) {
            await AsyncStorage.setItem('first_name', data.first_name);
            await AsyncStorage.setItem('last_name', data.last_name);
        }

        return response;
    });

    static updateProfileWithEmail = UserController.exceptionWrapper(async (data) => {
        console.log('getting to data', data)
        let response = await UtilitiesController.post(`/v4/api/user/update_profile_with_email`, data, true);
        console.log('response', response)
        if(response && response.success) {
            await AsyncStorage.setItem('email', data.email);
            await AsyncStorage.setItem('first_name', data.first_name);
            await AsyncStorage.setItem('last_name', data.last_name);
        }

        return response;
    });

    static updateProfileImage = UserController.exceptionWrapper(async (image) => {
        const data = new FormData();

        let response;
        if(image) {
            if(Platform.OS === 'web') {
                console.log('GETTING TO STRING', image)
                response = await UtilitiesController.post(`/v4/api/user/upload_profile_image`, {image: image.uri, base64: true}, true);
            } else {
                data.append('file', {
                    uri: image.uri,
                    type: Platform.OS === 'android' ? 'image/jpeg' : image.type,
                    name: 'photo_url.jpeg',
                });

                response = await UtilitiesController.uploadImageWithValues(data, `/v4/api/user/upload_profile_image`);
            }
        }

        console.log('response', response)

        return response;
    });

    static refreshUserTags = UserController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post(`/v4/api/user/refresh_category_tags`, data, true);
        return response;
    });

    static getUserArticles = UserController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.get(`/v4/api/user/get_articles`, data, true);
        return response;
    });

    static sendDataToAirTable = UserController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post(`/v4/add_air_table`, data, true);
        return response;
    });

    static updateUserPartnerRegistration = UserController.exceptionWrapper(async (data) => {
        let partner_code = data.partner_code;
        let status       = data.status;
        let response     = await UtilitiesController.post(`/v4/api/user/partner_registration/${partner_code}/${status}`, data, true);
        return response;
    });

    static textAppDownloadLink = UserController.exceptionWrapper(async (data) => {
        let response     = await UtilitiesController.post(`/v4/api/user/text_download_link`, data, true);
        return response;
    });

    static getNewUserArticles = UserController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.get(`/v4/get_new_user_articles`, data, true);
        return response;
    });

    static getSubscriptionManageUrl = UserController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post(`/v4/api/user/retrieve_sub_manage_url`, data, true);
        return response;
    });
}
